import { Component } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import * as fromStore from '../store';
import { select, Store } from '@ngrx/store';
import * as fromModels from '../models';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-job-status-summary',
  templateUrl: './job-status-summary.component.html'
})
export class JobStatusSummaryComponent {
  searchResultsState$: Observable<fromStore.SummaryState>;

  private _subscription: Subscription;
  private _searchCriteria: fromModels.LoadJobStatusListRequest;
  private _pagingSorting: fromModels.PagingSorting;

  constructor(private _store: Store<fromStore.JobState>, private route: ActivatedRoute, private router: Router) {}

  ngOnInit() {
    this.searchResultsState$ = this._store.pipe(select(fromStore.getJobStatusSummaryState));

    this._subscription = this.searchResultsState$.subscribe(s => {
      this._searchCriteria = s.searchCriteria;
      this._pagingSorting = s.pagingSorting;
    });

    // Subscribe to query params
    this.route.queryParams.subscribe(params => {
      this._store.dispatch(new fromStore.ProcessQueryString(this.router.url));
    });
  }

  onDestroy() {
    this._subscription.unsubscribe();
  }

  nextPage() {
    // Run the search again with the new parameters
    this._store.dispatch(new fromStore.NextPage(this._searchCriteria, this._pagingSorting));
  }

  prevPage() {
    // Run the search again with the new parameters
    this._store.dispatch(new fromStore.PrevPage(this._searchCriteria, this._pagingSorting));
  }

  setPageSize(pageSize: number) {
    // Run the search again with the new parameters
    this._store.dispatch(new fromStore.SetPageSize(pageSize, this._searchCriteria));
  }

  lastPage() {
    // Run the search again with the new parameters
    this._store.dispatch(new fromStore.LastPage(this._searchCriteria, this._pagingSorting));
  }

  firstPage() {
    // Run the search again with the new parameters
    this._store.dispatch(new fromStore.FirstPage(this._searchCriteria, this._pagingSorting));
  }

  sortBy(column: string) {
    // Run the search again with the new parameters
    this._store.dispatch(new fromStore.SortBy(column, this._searchCriteria, this._pagingSorting));
  }

  getJobStateName(state: number) {
    const jobState = fromModels.jobStates.find(js => js.value === state);
    return jobState ? jobState.key : 'Unknown';
  }

  getTriggerTypeName(triggerType: fromModels.TriggerType) {
    const triggerTypeValue = fromModels.triggerTypes.find(tt => tt.value === triggerType);
    return triggerTypeValue ? triggerTypeValue.key : 'Unknown';
  }
}
